import React, { useEffect, useMemo, useState } from "react";
import * as api from "../api";
import { audioUrl, exportRatingExcel, exportRatingExcelSilent } from "../api";
import AudioPlayer from "../components/AudioPlayer";



function inferSelFromPoints(item, fatal) {
  if (fatal) {
    const u = String(item.points ?? "").toUpperCase();
    if (u === "YES") return "Yes";
    if (u === "NO") return "No";
    if (u === "NA") return "NA";
    return "";
  }
  const p = item.points;
  if (p === "" || p === undefined || p === null) return "";
  const n = Number(p);
  if (!Number.isFinite(n)) {
    const v = String(p).toUpperCase();
    return v === "NA" ? "NA" : v === "1" ? "1" : v === "0" ? "0" : "";
  }
  return n > 0 ? "1" : "0";
}

function itemPoints(item, fatal) {
  if (fatal) return 0;
  const sel = (item.sel ?? "").toUpperCase();
  if (sel === "1" || sel === "NA") return Number(item.max) || 0;

  const p = Number(item.points);
  if (Number.isFinite(p)) return Math.max(0, p);
  const v = String(item.points ?? "").toUpperCase();
  return v === "1" || v === "NA" ? (Number(item.max) || 0) : 0;
}

export default function RatingsPage({ fileId, onSaved }) {
  const initial = useMemo(
    () => [
      {
        id: "А",
        title: "А) Начало на разговор",
        items: [
          { id: "А1", label: "Правилна идентификация при вх. и изх. обаждания", max: 5, points: "" },
          { id: "А2", label: "Коректно Представяне на Оператора (име и компанията на изходящо)", max: 3, points: "" },
          { id: "А3", label: "Съгласие и причина за разговор", max: 2, points: "" },
          { id: "А4", label: "Изслушване на К, за да се изясни причината за обаждане", max: 3, points: "" },
        ],
        open: false,
      },
      {
        id: "Б",
        title: "Б) Познаване и спазване на процедури, скриптове и правилата за работа/GDPR правила",
        items: [
          { id: "Б1", label: "Подаване на коректна информация относно кредита/ вкл. АНКЕТА", max: 4, points: "" },
          { id: "Б2", label: "Спазване на GDPR правила", max: 5, points: "" },
        ],
        open: false,
      },
      {
        id: "В",
        title: "В) Продажбени умения на оператора",
        items: [
          { id: "В1", label: "Презентиране на продукти, предложения/Кампания", max: 5, points: "" },
          { id: "В2", label: "Задаване на въпроси с цел установяване на нуждите на клиента", max: 4, points: "" },
          { id: "В3", label: "Лесно, достъпно и разбираемо презентиране на продуктите", max: 3, points: "" },
          { id: "В4", label: "Лесно, достъпно и разбираемо презентиране на продуктите", max: 3, points: "" },
          { id: "В5", label: "Агресия за продажба", max: 3, points: "" },
          { id: "В6", label: "Способност за оборване на възражения от клиента", max: 4, points: "" },
        ],
        open: false,
      },
      {
        id: "Г",
        title: "Г) Звучене на оператора",
        items: [
          { id: "Г1", label: "Тон на гласа", max: 3, points: "" },
          { id: "Г2", label: "Финес в разговора", max: 3, points: "" },
          { id: "Г3", label: "Бързина на говорене", max: 2, points: "" },
          { id: "Г4", label: "Увереност", max: 3, points: "" },
          { id: "Г5", label: "Способност да се изразява правилно, дикция, употреба на жаргони и тн.", max: 3, points: "" },
          { id: "Г6", label: "Излишно/изкуствено увеличаване на продължителността на разговора", max: 3, points: "" },
        ],
        open: false,
      },
    ],
    []
  );

  const [audioSrc, setAudioSrc] = useState(null);
  const [audioErr, setAudioErr] = useState(null);

  useEffect(() => {
    let alive = true;
    setAudioSrc(null);
    setAudioErr(null);
    if (!fileId) return;
    (async () => {
      try {
        const { url } = await audioUrl(fileId);
        if (alive) setAudioSrc(url);
      } catch (e) {
        console.error(e);
        if (alive) setAudioErr("Няма аудио или няма достъп.");
      }
    })();
    return () => { alive = false; };
  }, [fileId]);

  const [sections, setSections] = useState(initial);
  const [loading, setLoading] = useState(false);
  const [ratingUsage, setRatingUsage] = useState(null);

  const [selectedOperator, setSelectedOperator] = useState('');
  const [showComment, setShowComment] = useState(false);
  const [commentText, setCommentText] = useState('');
  const [showSummary, setShowSummary] = useState(false);
  const [summaryText, setSummaryText] = useState('');
  const [whyMap, setWhyMap] = useState({});

  function whyForItem(itemId) {
    if (!itemId) return "";
    const SEC_LATIN = { "А": "A", "Б": "B", "В": "C", "Г": "G" };
    const secCyr = itemId[0];
    const num = itemId.slice(1);
    const latin = (SEC_LATIN[secCyr] || secCyr) + num;

    return (whyMap && (whyMap[latin] || whyMap[itemId])) || "";
  }

  const operators = useMemo(() => ([
    { id: 'op1', name: 'Иван Иванов' },
    { id: 'op2', name: 'Мария Петрова' },
    { id: 'op3', name: 'Георги Димитров' },
  ]), []);

  const [templateId, setTemplateId] = useState(null);

  useEffect(() => {
    if (!fileId) return;
    (async () => {
      try {
        const saved = await api.getRating(fileId);
        setTemplateId(saved.template_id || null);

        if (Array.isArray(saved.sections) && saved.sections.length) {
          const normalized = saved.sections.map(s => ({
            ...s,
            items: (s.items || []).map(it => ({
              ...it,
              sel: it.sel ?? inferSelFromPoints(it, !!s.fatal),
            })),
          }));
          setSections(normalized);
          setWhyMap((saved.meta && saved.meta.why) || {});
        }

        const n = saved.notes || {};
        const opId = n.operator_id || "";
        const comm = n.comment || "";
        const summ = n.summary || "";

        setSelectedOperator(opId);
        setCommentText(comm);
        setShowComment(!!comm);
        setSummaryText(summ);
        setShowSummary(!!summ);

        setRatingUsage(saved.usage || null);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [fileId]);

  const selectedOp = operators.find(o => o.id === selectedOperator);


  const buildSavePayload = () => {
    const answers = {};
    sections.forEach(s => {
      if (s.fatal) return;
      (s.items || []).forEach(it => {
        const max = Number(it.max) || 0;
        const raw = String(it.sel ?? it.points ?? "").toUpperCase();

        if (raw === "NA" || raw === "") {
          answers[it.id] = "NA";
        } else if (typeof it.points === "number") {
          const n = Math.max(0, Math.min(Number(it.points) || 0, max));
          answers[it.id] = n;
        } else {
          answers[it.id] = raw === "1" ? max : 0;
        }
      });
    });

    return {
      template_id: templateId,
      answers,
      notes: {
        operator_id: selectedOperator || "",
        operator_name: selectedOp?.name || "",
        comment: commentText || "",
        summary: summaryText || "",
      },
    };
  };

  const totals = useMemo(() => {
    const bySection = sections
      .filter(s => !s.fatal)
      .map(s => {
        const max = s.items.reduce((a, b) => a + (Number(b.max) || 0), 0);
        const sum = s.items.reduce((a, b) => a + itemPoints(b, false), 0);
        const pct = max > 0 ? Math.round((sum / max) * 100) : 0;
        return { id: s.id, max, sum, pct };
      });

    const overallMax = bySection.reduce((a, b) => a + b.max, 0);
    const overallSum = bySection.reduce((a, b) => a + b.sum, 0);
    return { bySection, overallMax, overallSum };
  }, [sections]);

  const hasFatal = useMemo(() => {
    const fatalSection = sections.find(s => s.fatal);
    return fatalSection?.items.some(i => String(i.sel ?? i.points ?? "").toUpperCase() === "YES");
  }, [sections]);

  const percent = totals.overallMax > 0 ? Math.round((totals.overallSum / totals.overallMax) * 100) : 0;
  const finalPercent = hasFatal ? 0 : percent;

  const toggleOpen = (id) =>
    setSections(prev => prev.map(s => s.id === id ? { ...s, open: !s.open } : s));

  const updateSelection = (sid, iid, val) => {
    setSections(prev =>
      prev.map(s =>
        s.id === sid
          ? {
            ...s,
            items: s.items.map(it =>
              it.id === iid
                ? { ...it, points: val, sel: val }
                : it
            ),
          }
          : s
      )
    );
  };

  const handleSave = async () => {
    if (!fileId) return;
    if (!templateId) { alert("Липсва template_id за този рейтинг."); return; }

    try {
      setLoading(true);
      await api.saveRating(fileId, buildSavePayload());
      await exportRatingExcelSilent(fileId);
      onSaved?.();
      alert("Запазено!");
    } catch (e) {
      console.error(e);
      alert("Грешка при запис.");
    } finally {
      setLoading(false);
    }
  };


  const handleExcel = async () => {
    if (!fileId) return;
    try {
      setLoading(true);
      await api.saveRating(fileId, buildSavePayload());
      await exportRatingExcel(fileId);
    } catch (e) {
      console.error(e);
      alert("Грешка при експорт.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card rounded-2xl p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold">Оценки</h2>
        {ratingUsage && (ratingUsage.input > 0 || ratingUsage.output > 0) && (
          <div className="flex items-center gap-1">
            <span
              className="px-2 py-0.5 rounded-full bg-[#121825] border border-[#1f2638] text-[11px] leading-none text-slate-300"
              title="Входни токени (prompt)"
            >
              in {ratingUsage.input}
            </span>
            <span
              className="px-2 py-0.5 rounded-full bg-[#121825] border border-[#1f2638] text-[11px] leading-none text-slate-300"
              title="Изходни токени (completion)"
            >
              out {ratingUsage.output}
            </span>
            <span
              className="px-2 py-0.5 rounded-full bg-[#121825] border border-violet-700/40 text-[11px] leading-none text-slate-200 font-semibold"
              title="Общо токени"
            >
              tot {ratingUsage.total}
            </span>
          </div>
        )}
      </div>

      <div className="mb-4">
        {audioSrc ? (
          <AudioPlayer src={audioSrc} className="w-full" />
        ) : (
          <div className="rounded-xl border border-[#1f2638] bg-[#0e1320]/40 p-3 text-sm text-slate-400">
            {audioErr || "Зареждане на аудио…"}
          </div>
        )}
      </div>
      <div className="grid grid-cols-[20px,1fr,90px,80px] items-center px-4 py-2 text-sm font-semibold text-slate-300 bg-[#0e1320] rounded-t-2xl">
        <div></div>
        <div>Критерии</div>
        <div className="text-right">Точки</div>
        <div className="text-center">Оценка</div>
      </div>

      {sections.map(sec => (
        <div key={sec.id} className="border-t border-[#1f2638]">
          <div
            className="grid grid-cols-[20px,1fr,90px,80px] items-center px-4 pt-3 pb-1 bg-[#0e1320]/40 cursor-pointer hover:bg-[#0e1320]/60"
            onClick={() => toggleOpen(sec.id)}
          >
            <div className="justify-self-start text-slate-400">
              <svg className={`w-4 h-4 transition-transform ${sec.open ? "rotate-90" : ""}`} viewBox="0 0 20 20" fill="currentColor">
                <path d="M7 5l6 5-6 5V5z" />
              </svg>
            </div>
            <div className="font-semibold">{sec.title}</div>
            {!sec.fatal && (
              <>
                <div className="text-right">
                  {totals.bySection.find(x => x.id === sec.id)?.sum || 0} / {totals.bySection.find(x => x.id === sec.id)?.max || 0}
                </div>
                <div className="text-center font-semibold text-slate-300">
                  {totals.bySection.find(x => x.id === sec.id)?.pct || 0}%
                </div>
              </>
            )}
            {sec.fatal && <><div></div><div></div></>}
          </div>

          {sec.open && (
            <div className="divide-y divide-[#1f2638]">
              {sec.items.map(it => {
                const derived = sec.fatal ? "" : itemPoints(it, false);
                let selectValue = it.sel ?? "";
                if (selectValue === "" && !sec.fatal) {
                  const p = Number(it.points);
                  if (Number.isFinite(p)) selectValue = p > 0 ? "1" : "0";
                }
                return (
                  <div key={it.id} className="grid grid-cols-[20px,1fr,90px,80px] items-center px-4 py-3">
                    <div></div>
                    <div className="text-slate-200">
                      <span className="relative group inline-block tabular-nums">
                        <span
                          className="cursor-help focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-500/50 rounded-sm"
                          tabIndex={0}
                        >
                          {it.label}
                        </span>

                        {!!whyForItem(it.id) && (
                          <span
                            role="tooltip"
                            className="
          pointer-events-none absolute -top-2 left-0 -translate-y-full z-50
          invisible opacity-0 group-hover:visible group-hover:opacity-100
          group-focus-within:visible group-focus-within:opacity-100
          transition-opacity duration-150

          bg-[#0b1220] border border-[#1f2638] text-slate-200 text-xs
          rounded-xl px-3 py-2 shadow-xl

          min-w-[220px] md:min-w-[220px] max-w-[460px]
          whitespace-pre-line break-words
        "
                          >
                            {whyForItem(it.id)}
                            <span
                              aria-hidden="true"
                              className="
            absolute -bottom-1 left-4 w-2 h-2 rotate-45
            bg-[#0b1220] border-b border-r border-[#1f2638]
          "
                            />
                          </span>
                        )}
                      </span>
                    </div>


                    {!sec.fatal && (
                      <div className="text-right">
                        {(() => {
                          const p = it.points;
                          const isNum = typeof p === "number";
                          const chosen = isNum ? (p > 0 ? "1" : "0") : String(p || "").toUpperCase();
                          const pts = (chosen === "1" || chosen === "NA") ? Number(it.max) || 0 : 0;
                          return `${pts} / ${it.max}`;
                        })()}
                      </div>
                    )}
                    {sec.fatal && <div></div>}

                    <div className="text-center">
                      <select
                        value={(() => {
                          const raw = String(it.points ?? it.sel ?? "");
                          const u = raw.toUpperCase();

                          if (sec.fatal) {
                            if (u === "YES") return "Yes";
                            if (u === "NO") return "No";
                            if (u === "NA") return "NA";
                            return "";
                          } else {
                            if (typeof it.points === "number") return it.points > 0 ? "1" : "0";
                            if (u === "1") return "1";
                            if (u === "0") return "0";
                            if (u === "NA") return "NA";
                            return "";
                          }
                        })()}
                        className="bg-[#121825] border border-[#1f2638] rounded-lg px-2 py-1 text-sm outline-none"
                        onChange={(e) => {
                          const v = e.target.value;
                          updateSelection(
                            sec.id,
                            it.id,
                            sec.fatal ? (v === "Yes" ? "Yes" : v === "No" ? "No" : "NA")
                              : (v === "1" || v === "0" ? v : "NA")
                          );
                        }}
                        disabled={loading}
                      >
                        <option value="" disabled hidden></option>
                        {sec.fatal ? (
                          <>
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                            <option value="NA">NA</option>
                          </>
                        ) : (
                          <>
                            <option value="1">1</option>
                            <option value="0">0</option>
                            <option value="NA">NA</option>
                          </>
                        )}
                      </select>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ))}

      <div className="mt-4 rounded-2xl border border-[#1f2638] bg-[#0e1320]/50">
        <div className="p-4 grid gap-6 md:grid-cols-2">
          <div className="space-y-2">
            <label htmlFor="operator" className="text-sm font-semibold text-slate-300">
              Оператор
            </label>
            <div className="relative">
              <select
                id="operator"
                className="w-full appearance-none bg-[#121825] border border-[#1f2638] rounded-xl px-3 py-2 pr-9 text-sm text-slate-200
                     outline-none focus:ring-2 focus:ring-violet-600/40"
                value={selectedOperator}
                onChange={(e) => setSelectedOperator(e.target.value)}
              >
                <option value="" disabled>Изберете оператор…</option>
                {operators.map(o => (
                  <option key={o.id} value={o.id}>{o.name}</option>
                ))}
              </select>
              <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 opacity-70">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M7 10l5 5 5-5H7z" /></svg>
              </span>
            </div>
            <p className="text-xs text-slate-500">
              Изберете служител, към когото се отнася оценката.
            </p>
          </div>

          <div className="space-y-4">
            <div className="space-y-2">
              <label className="inline-flex items-center gap-2 cursor-pointer select-none">
                <input
                  type="checkbox"
                  className="form-checkbox h-4 w-4 rounded border-[#1f2638] bg-[#121825] text-violet-500"
                  checked={showComment}
                  onChange={(e) => setShowComment(e.target.checked)}
                />
                <span className="text-sm text-slate-300">Коментар</span>
              </label>

              {showComment && (
                <div>
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-xs text-slate-400">Кратък коментар към оценката</span>
                    <span className="text-[11px] text-slate-500 tabular-nums">{commentText.length} знака</span>
                  </div>
                  <textarea
                    rows={3}
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                    placeholder="Напр. конкретни забележки, контекст, препоръки…"
                    className="w-full resize-y rounded-lg bg-[#121825] border border-[#1f2638] px-3 py-2 text-sm text-slate-200 outline-none
                         focus:ring-2 focus:ring-violet-600/40 nice-scrollbar"
                  />
                </div>
              )}
            </div>

            <div className="space-y-2">
              <label className="inline-flex items-center gap-2 cursor-pointer select-none">
                <input
                  type="checkbox"
                  className="form-checkbox h-4 w-4 rounded border-[#1f2638] bg-[#121825] text-violet-500"
                  checked={showSummary}
                  onChange={(e) => setShowSummary(e.target.checked)}
                />
                <span className="text-sm text-slate-300">Обобщение</span>
              </label>

              {showSummary && (
                <div>
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-xs text-slate-400">Обобщение</span>
                    <span className="text-[11px] text-slate-500 tabular-nums">{summaryText.length} знака</span>
                  </div>
                  <textarea
                    rows={3}
                    value={summaryText}
                    onChange={(e) => setSummaryText(e.target.value)}
                    placeholder="Кратко обобщение (напр. 2–3 изречения)…"
                    className="w-full resize-y rounded-lg bg-[#121825] border border-[#1f2638] px-3 py-2 text-sm text-slate-200 outline-none
                         focus:ring-2 focus:ring-violet-600/40 nice-scrollbar"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center">
        <div className="rounded-xl border border-[#1f2638] bg-[#0e1320]/60 px-3 py-2 text-sm">
          Общо: <span className="font-semibold">{totals.overallSum}</span> / {totals.overallMax}
          <span className="ml-2 text-slate-400">({percent}%)</span>
        </div>
        <div className="rounded-xl border border-[#1f2638] bg-[#0e1320]/60 px-3 py-2 text-sm sm:ml-4">
          Краен резултат от мониторинг на обаждането: <span className="font-semibold">{finalPercent}%</span>
        </div>
        <div className="sm:ml-auto flex gap-2">
          <button className="btn btn-primary" onClick={handleSave} disabled={loading || !fileId}>
            {loading ? "Запис…" : "Запази"}
          </button>
        </div>
      </div>
    </div>
  );
}
